import React, {Fragment, useEffect, useState} from 'react';
import RUFormService from "../../../../services/RUFormService";
import NumberFormat from "react-number-format";
import FormService from "../../../../services/FormsService";


const TemplateCUBUrbaDemo = (props) => {

    const ruFormService = new RUFormService()
    const formService = new FormService();
    const [items, setItems]= useState([])
    const [items2, setItems2]= useState()
    const [dateValid, setDateValide] = useState('')
    const [parcelles, setParcelles] = useState(ruFormService.getData('parcelles'))
    const fetchData = ruFormService.getData('urba')
    const fetchData2 = ruFormService.getData('urba2')
    const [annexes, setAnnexes] = useState();
    const [headingInfo, setHeadingInfo] = useState();

    useEffect(()=>{

    }, [])

    useEffect(()=>{
        (fetchData)?setItems(fetchData):null;
        setAnnexes(formService.getEntityAnnexes())
        setHeadingInfo(formService.getEntityHeadingInfo())

    },[fetchData])

    useEffect(()=>{
        (fetchData2)?setItems2(fetchData2):null;
    },[fetchData2])

    useEffect(()=>{
        //console.log(parcelles);
    }, [parcelles])


    return (
        <div style={{"width":"100%"}}>
            <div>
                <hr/>
                <table className={"ue-form-table-basic "} style={{"marginTop":"15px", "marginBottom":"15px", "fontSize": "10pt", "fontWeight":"400"}}>
                    <tbody>
                   <tr >
                       <td style={{"width": "25%",  "height":"2rem"}}>Demandeur </td>
                       <td>
                           <div id="acquir_name">Jacque XXXXXX</div>
                       </td>
                   </tr>
                    <tr>
                        <td style={{"width":"25%", "height":"2rem"}}>Localisation du bien</td>
                        <td>
                            <div id="address_bien">{props?.demInfo?.dem_addr}</div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{"height":"2rem"}}>Parcelle(s)</td>
                        <td>
                            {
                                (parcelles)?
                                    parcelles.map((item,index)=>{
                                        return <span key={index} style={{"marginRight":"8px"}}>{item.id.slice(-6)} ('0000' ca)</span>
                                    })
                                    :null
                            }
                        </td>
                    </tr >
                    <tr>
                        <td style={{"height":"2rem"}}>Surface total</td>
                        <td>
                            {
                                (parcelles)?
                                    <span>XXX,XX  m<sup>2</sup></span>
                                    :null
                            }
                        </td>
                   </tr>
                   {(props.formtype === 'cub') ?
                       <tr>
                           <td style={{"height":"2rem"}}>Projet :</td>
                           <td>
                               <div id="form_process"/>
                           </td>
                       </tr>
                       : null
                   }
                    </tbody>
                </table>

            </div>
            <hr/>
             <div>
                 <br/>
                 {(annexes?.intro_txt && annexes?.intro_txt!=='')?
                     <p style={{'whiteSpace':'pre-line'}}  dangerouslySetInnerHTML={{__html:annexes.intro_txt.replace(/(?:\r\n|\r|\n)/g, '<br />')}}/>
                     :(props.formtype === 'ru')?
                         <p style={{"fontSize": "10pt"}}>
                             Ces renseignements sont donnés à titre informatif et ne présagent en aucun cas de la constructibilité du terrain et de ses prescriptions particulières pour lesquelles il est nécessaire de demander un Certifcat d’Urbanisme (Article L.410-1 et suivants ; R.410-1 et suivants du Code de l’Urbanisme).
                         </p>
                         : <p style={{"fontSize": "10pt"}}>
                             Le Maire,
                             <br/><br/>
                             Vu la demande d’un certificat d’urbanisme indiquant, en application des articles L 410-1, R
                             410-1 et suivants du code de l’urbanisme, les dispositions d’urbanisme, les limitations
                             administratives au droit de propriété et la liste des taxes et participations applicables.

                         </p>
                 }
                <br/>
           </div>
            <div className="text-center">
                {(props.formtype === 'ru') ?<h4>***** INFORME DÉMO *****</h4>:<h4>***** CERTIFIE DÉMO *****</h4>}
            </div>
            <br/>
            {(props.formtype === 'cub') ?
                <div>
                    <h3 className={"text-center"}>- L’opération désignée ci-dessus est réalisable avec prescriptions</h3>
                    <br/>
                    <br/>
                </div>
                : null
            }
            {(props.formtype !== 'ru') ?
                <div>
                    <div className="text-left text-underline">
                        <h3>ARTICLE 1 - Règle d’urbanisme</h3>
                    </div>

                    {(annexes?.a1_txt && annexes?.a1_txt !== '') ?
                        <p style={{'whiteSpace':'pre-line'}}  dangerouslySetInnerHTML={{__html:annexes.a1_txt.replace(/(?:\r\n|\r|\n)/g, '<br />')}}/>
                        : <>
                            <p>- Les règles d’urbanisme, la liste des taxes et participations d’urbanisme ainsi que les
                                limitations
                                administratives au droit de propriété applicables au terrain sont mentionnées au présent
                                certificat.
                            </p>
                            <p>
                                Conformément au quatrième alinéa de l’article L 410-1 du code de l’urbanisme, si une
                                demande
                                de permis de construire, d’aménager ou de démolir ou si une déclaration préalable est
                                déposée dans le délai de
                                dix-huit mois à compter de la date du présent certificat d’urbanisme, les
                                dispositions d’urbanisme, le régime des taxes et participations d’urbanisme ainsi que
                                les
                                limitations administratives au droit de propriété tels qu’ils existaient à cette date ne
                                peuvent être
                                remis en cause à l’exception des dispositions qui ont pour objet la préservation de la
                                sécurité ou de la
                                salubrité publique.
                            </p>
                        </>
                    }
                    <br/>

                </div>
                : null
            }

        </div>
    );
};

export default TemplateCUBUrbaDemo;


